import { render, staticRenderFns } from "./SipUser.vue?vue&type=template&id=ff2f2582&scoped=true"
import script from "./SipUser.vue?vue&type=script&lang=js"
export * from "./SipUser.vue?vue&type=script&lang=js"
import style0 from "./SipUser.vue?vue&type=style&index=0&id=ff2f2582&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f2582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff2f2582')) {
      api.createRecord('ff2f2582', component.options)
    } else {
      api.reload('ff2f2582', component.options)
    }
    module.hot.accept("./SipUser.vue?vue&type=template&id=ff2f2582&scoped=true", function () {
      api.rerender('ff2f2582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/sips/SipUser.vue"
export default component.exports